'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _avatar = require('../avatar');

var _avatar2 = _interopRequireDefault(_avatar);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var displayName = 'Profile';

var propTypes = {
  /** The user's username */
  header: _propTypes2.default.node.isRequired,
  /** Secondary text line */
  secondaryText: _propTypes2.default.node,
  /** Path to the user's profile image will only be rendered if there is one */
  avatar: _propTypes2.default.string,
  /** Path to the user's coverimage will only be rendered if there is one */
  coverImage: _propTypes2.default.string,
  /** Profile action button */
  button: _propTypes2.default.node,
  /** Profile content */
  children: _propTypes2.default.node,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the cover element */
  coverStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the coverImage element */
  coverImageStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the header element */
  headerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the secondaryText element */
  secondaryTextStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the avatar element */
  avatarStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** An user's status. One of the following: ["online", "away", "offline"] */
  status: _propTypes2.default.oneOf(['online', 'away', 'offline', ''])
};

var defaultProps = {
  avatar: '',
  coverImage: '',
  children: null,
  button: null,
  secondaryText: '',
  style: {},
  coverStyle: {},
  coverImageStyle: {},
  headerStyle: {},
  secondaryTextStyle: {},
  avatarStyle: {},
  status: ''
};

/** Profile useful for showing a user's info */
var Profile = function Profile(_ref) {
  var header = _ref.header,
      secondaryText = _ref.secondaryText,
      secondaryTextStyle = _ref.secondaryTextStyle,
      avatar = _ref.avatar,
      coverImage = _ref.coverImage,
      button = _ref.button,
      children = _ref.children,
      style = _ref.style,
      coverStyle = _ref.coverStyle,
      coverImageStyle = _ref.coverImageStyle,
      headerStyle = _ref.headerStyle,
      avatarStyle = _ref.avatarStyle,
      status = _ref.status,
      custom = _objectWithoutProperties(_ref, ['header', 'secondaryText', 'secondaryTextStyle', 'avatar', 'coverImage', 'button', 'children', 'style', 'coverStyle', 'coverImageStyle', 'headerStyle', 'avatarStyle', 'status']);

  var coverBackground = {
    backgroundImage: 'url(' + coverImage + ')'
  };

  return _react2.default.createElement(
    'section',
    _extends({ style: _getStyles2.default.root(style) }, custom),
    _react2.default.createElement(
      'section',
      { style: _getStyles2.default.cover(coverStyle) },
      _react2.default.createElement('section', { style: _getStyles2.default.coverImage(coverBackground, coverImageStyle) })
    ),
    avatar ? _react2.default.createElement(_avatar2.default, {
      image: avatar,
      style: _getStyles2.default.avatar(avatarStyle),
      statusStyle: _styles2.default.status,
      status: status
    }) : null,
    _react2.default.createElement(
      'h1',
      { style: _getStyles2.default.header(headerStyle) },
      header
    ),
    secondaryText ? _react2.default.createElement(
      'p',
      { style: _getStyles2.default.secondaryText(secondaryTextStyle) },
      secondaryText
    ) : null,
    button,
    children
  );
};

Profile.displayName = displayName;
Profile.propTypes = propTypes;
Profile.defaultProps = defaultProps;

exports.default = Profile;
module.exports = exports.default;